import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import cn from 'classnames';

import Permitted from 'components/core/Permitted.component';
import SalonFlag from 'components/core/SalonFlag.component';
import WhenSalonFlag from 'components/core/WhenSalonFlag.component';
import Tooltip from 'components/generic/Tooltip.component';
import TooltipContentReceptionist from 'components/generic/TooltipContentReceptionist.component';
import FLAG from 'config/flag.singleton';
import PERM from 'constants/core/perm.const';
import LINK from 'constants/link.const';
import SF from 'constants/salonFlag.const';
import S from 'constants/string.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import linkTo from 'utils/links/linkTo.util';

import CN from './HumanResourcesMenu.module.scss';

const MenuItem = ({ icon, children, disabled, ...rest }) => {
  const menuItemDisabledClass = disabled ? CN.menuItemDisabled : CN.menuItem;
  return (
    <NavLink {...rest} className={menuItemDisabledClass} activeClassName={CN.selected}>
      <div className={CN.hoverContainer}>
        <div className={CN.menuText}>
          <div className={cn(CN[`${icon}Icon`])} />
          <div>{children}</div>
        </div>
      </div>
    </NavLink>
  );
};

const HumanResourcesMenu = () => {
  const { isDarkMode } = useTheme();
  const salonId = useCurrentSalonId();

  const linkHr = linkTo({ pattern: LINK.hrSplash, params: { salonId }, fault: '#' });
  const linkEditKpi = linkTo({ pattern: LINK.hrEditKpi, params: { salonId }, fault: '#' });
  const linkTimeOff = linkTo({ pattern: LINK.hrTimeoff, params: { salonId }, fault: '#' });
  const linkTargets = linkTo({ pattern: LINK.hrTargets, params: { salonId }, fault: '#' });
  const linkCommissions = linkTo({ pattern: LINK.hrCommissions, params: { salonId }, fault: '#' });

  const renderedTooltipPlan = (
    <div>
      {S.star}
      {S.space}Upgrade plan to access
    </div>
  );

  const renderedTooltipComingSoon = (
    <div>
      {S.partyingFace}
      {S.space}Coming Soon!
    </div>
  );

  return (
    <div
      data-bem="HumanResourcesMenu"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div data-bem="HumanResourcesMenu__sub-menu" className={CN.container}>
        <MenuItem icon="hr" to={linkHr}>
          HR Overview
        </MenuItem>
        <MenuItem icon="kpi" to={linkEditKpi}>
          Customise KPIs
        </MenuItem>
        {FLAG.tabTargets && (
          <Tooltip variant="comingSoon" position="bottom" content={renderedTooltipComingSoon}>
            <MenuItem icon="targets" to={linkTargets} disabled={true}>
              Set Staff Targets
            </MenuItem>
          </Tooltip>
        )}

        <WhenSalonFlag disabled name={SF.timeOffCats}>
          <Tooltip variant="primaryBottom" content={renderedTooltipPlan}>
            <MenuItem icon="time" to={linkTimeOff} disabled={true}>
              Time-off Allowances
            </MenuItem>
          </Tooltip>
        </WhenSalonFlag>

        <SalonFlag name={SF.timeOffCats}>
          <SalonFlag.IfEnabled>
            <MenuItem icon="time" to={linkTimeOff}>
              Time-off Allowances
            </MenuItem>
          </SalonFlag.IfEnabled>
        </SalonFlag>
        <Permitted not value={PERM.canEditStaffCommissions} tag="HumanResourcesMenu__can-not-edit-commissions">
          <Tooltip variant="slickTop" content={<TooltipContentReceptionist />}>
            <MenuItem icon="money" to={linkCommissions} disabled={true}>
              Split Takings
            </MenuItem>
          </Tooltip>
        </Permitted>
        <Permitted value={PERM.canEditStaffCommissions} tag="HumanResourcesMenu__can-edit-commissions">
          <MenuItem icon="money" to={linkCommissions}>
            Split Takings
          </MenuItem>
        </Permitted>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
});

const HumanResourcesMenuHoc = withRouter(connect(mapStateToProps)(HumanResourcesMenu));

export default HumanResourcesMenuHoc;
